import { SxProps, Theme } from '@mui/material';
import { Colors } from '@sweatpals/react-ui-kit';

export const sponsorListRootStyles: SxProps<Theme> = {
	display: 'flex',
	flexDirection: 'column',
	gap: '16px',
};

export const sponsorListTitleStyles: SxProps<Theme> = {
	fontFamily: ' Integral CF, sans-serif',
	fontSize: '20px',
	fontWeight: '600',
	color: Colors.white,
};

export const sponsorListStyles: SxProps<Theme> = {
	display: 'flex',
	gap: '32px',
	flexWrap: { xs: 'nowrap', md: 'wrap' },
	alignItems: 'flex-start',
	overflowX: { xs: 'auto', md: 'initial' },

	'&::-webkit-scrollbar': {
		height: '0px',
	},

	'&::-webkit-scrollbar-thumb': {
		borderRadius: '2px',
		backgroundColor: 'rgba(250, 250, 250, 0.7)',
	},
};

export const sponsorCardStyles: SxProps<Theme> = {
	display: 'inline-flex',
	flexDirection: { xs: 'column', md: 'row' },
	alignItems: 'center',
	flexShrink: 0,
	gap: '22px',
	pr: '26px',
	backgroundColor: Colors.transparent,
	border: 'none',
	minHeight: '64px',
	cursor: 'pointer',
	textDecorationColor: 'white',

	'&:hover': {
		textDecoration: 'white underline',
	},
};

export const sponsorCardAvatarStyles: SxProps<Theme> = {
	height: '64px',
	width: '64px',
	borderRadius: '50%',
	border: `1px solid ${Colors.white_a5}`,
};

export const sponsorNameStyles: SxProps<Theme> = {
	fontFamily: 'Integral CF, sans-serif',
	fontSize: '18px',
	fontWeight: '700',
	color: 'white',
	textAlign: 'left',
	wordBreak: 'break-word',
	maxWidth: 'fit-content',
	background: 'linear-gradient(92deg, #FFF 70.68%, #999 98.07%)',
	backgroundClip: 'text',
	WebkitBackgroundClip: 'text',
	WebkitTextFillColor: 'transparent',
};
